
import { defineComponent, onMounted } from 'vue'
import { analyticsClickTrack } from '@/core/modules/analytics/services/analytics.click.track';

export default defineComponent({
	props: {
		modifier: {
			type: String, 
			default: 'default',
		}
	},
	setup () {
		onMounted(() => {
			analyticsClickTrack();
			layoutHeight();

			window.addEventListener('resize', layoutHeight);
		});

		const layoutHeight = () => {
			document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
		};

		return {};
	},
})
